import React from "react";
import "../styles/AboutUs.css";
import circleImg from "../assets/circle.webp";
import ad2 from "../assets/ad2.webp";
import ad3 from "../assets/rupay728x90.png";
import ad5 from '../assets/ad5.webp';
import { FaUmbrellaBeach, FaMoneyBillWave, FaMapMarkedAlt } from "react-icons/fa";

const AboutUs = () => {
  return (
    <section className="about-us-section">
        <div className="ads">
        <a href="https://www.etihad.com/en-in/" target="_blank" rel="noopener noreferrer">
          <img src={ad2} alt="Advertisement" />
        </a>
        <br />
         <a href="https://www.rupay.co.in/credit-cards?utm_source=perfpartner&utm_medium=cpapplynow&utm_campaign=rupay-iplsurround&utm_id=sm-creditcard-rupay2026-creditcard-RS-static-blue-english-static-IA-424_" target="_blank" rel="noopener noreferrer">
          <img src={ad3} alt="Advertisement" />
        </a>
      </div>
      <div className="about-left">
        <h4 className="about-highlight">About Us</h4>
        <h2 className="about-heading">Explore the Best Tours Around the World with Us.</h2>
        <p className="about-desc">
Discover unforgettable travel experiences and explore breathtaking destinations worldwide with personalized tour packages, adventure trips, and memorable journeys designed for every traveler.
        </p>

        <div className="about-features">
          <div className="feature-item">
            <FaMapMarkedAlt className="feature-icon" />
            <div>
              <h4>Tour guide</h4>
<p>Our experienced local travel guides help you explore top destinations, hidden gems, cultural attractions, and unique experiences you won’t find in ordinary travel guidebooks.</p>
            </div>
          </div>

          <div className="feature-item">
            <FaMoneyBillWave className="feature-icon" />
            <div>
              <h4>Affordable Adventures</h4>
<p>Discover affordable travel packages with exceptional quality, competitive pricing, and transparent costs—making your dream vacation and unforgettable travel experiences more accessible than ever.</p>
            </div>
          </div>

          <div className="feature-item">
            <FaUmbrellaBeach className="feature-icon" />
            <div>
              <h4>Reliable & Safe Travel</h4>
<p>Enjoy safe, hassle-free travel with expertly planned tours, reliable customer support, secure booking services, and seamless travel experiences from start to finish.</p>            </div>
          </div>
        </div>
      </div>

      <div className="about-right">
  <img src={circleImg} alt="Travel Visual" className="circle-img" />
</div>
 <div className="ad">
        <a href="https://invl.me/clmtayi" target="_blank" rel="noopener noreferrer">
          <img src={ad5} alt="Advertisement" />
        </a>
      </div>
    </section>
  );
};

export default AboutUs;
